/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const createDAO = /* GraphQL */ `
  mutation CreateDAO(
    $input: CreateDAOInput!
    $condition: ModelDAOConditionInput
  ) {
    createDAO(input: $input, condition: $condition) {
      id
      searchField
      name
      treasuryAddresses {
        address
        description
      }
      tokenAddresses {
        address
        description
      }
      factories
      fora
      formationDate
      reviewDate
      status
      type
      amlStatus
      legalRepresentative {
        name
        contact
      }
      registrations
      presence
      exclusions
      wrappers {
        name
        jurisdiction
        regulator
        functions
      }
      contact {
        name
        email
        phone
        company
        role
      }
      createdAt
      updatedAt
    }
  }
`;
export const updateDAO = /* GraphQL */ `
  mutation UpdateDAO(
    $input: UpdateDAOInput!
    $condition: ModelDAOConditionInput
  ) {
    updateDAO(input: $input, condition: $condition) {
      id
      searchField
      name
      treasuryAddresses {
        address
        description
      }
      tokenAddresses {
        address
        description
      }
      factories
      fora
      formationDate
      reviewDate
      status
      type
      amlStatus
      legalRepresentative {
        name
        contact
      }
      registrations
      presence
      exclusions
      wrappers {
        name
        jurisdiction
        regulator
        functions
      }
      contact {
        name
        email
        phone
        company
        role
      }
      createdAt
      updatedAt
    }
  }
`;
export const deleteDAO = /* GraphQL */ `
  mutation DeleteDAO(
    $input: DeleteDAOInput!
    $condition: ModelDAOConditionInput
  ) {
    deleteDAO(input: $input, condition: $condition) {
      id
      searchField
      name
      treasuryAddresses {
        address
        description
      }
      tokenAddresses {
        address
        description
      }
      factories
      fora
      formationDate
      reviewDate
      status
      type
      amlStatus
      legalRepresentative {
        name
        contact
      }
      registrations
      presence
      exclusions
      wrappers {
        name
        jurisdiction
        regulator
        functions
      }
      contact {
        name
        email
        phone
        company
        role
      }
      createdAt
      updatedAt
    }
  }
`;
